import React, { Component } from 'react';
import styled from 'styled-components';

import { updateLanguage } from 'react-localize-redux';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import * as FullStory from '@fullstory/browser';

import Auth from 'j-toker';
import { BounceLoader } from 'halogenium';

import { Button } from '@material-ui/core';
import FlatButton from 'material-ui/FlatButton';
import { MdWarning as WarningIcon } from 'react-icons/md';
import { MdCheckCircle as CheckIcon } from 'react-icons/md';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import LoginHelpDialog from 'navigation/LoginHelpDialog';

import { hostIsConcert, hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { Input } from 'components/ui/Input';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';

import {
  showLoginError,
  toggleAuthenticationDialog,
  logUserIn,
} from 'actions/authenticationActions';
import {
  setUserAsLead,
  setUserAsLandlord,
  setUserAsMaintenance,
  setLandlordLogo,
} from 'actions/userTypesActions';
import { showFailureFromUrlQuery } from 'actions/notificationActions';
import { getCompanyPreferences } from 'actions/companyDetailsActions';
import { getPortfolios } from 'actions/landlordPropertiesActions';

import { dashboardForAgent } from 'helpers/RouterHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import constants from 'config/constants';
import { colors } from 'helpers/ColorHelper';
import { titleize, formatPhone } from 'helpers/Formatter';
import msIcon from 'assets/microsoft-sso.png';
import oktaIcon from 'assets/okta-sso.png';
import LanguageOptionsCentered from 'components/shared/LanguageOptionsCentered';
import ReactPhoneInput from 'components/shared/ReactPhoneInput';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import FormHelperText from '@material-ui/core/FormHelperText';

const style = {
  welcomeMessage: {
    paddingTop: '0',
    marginTop: '5px',
    marginBottom: '10px',
  },
  text_field_margin: {
    fontSize: '14px',
  },
  button: {
    marginTop: '20px',
    width: '100%',
    color: 'white',
    fontSize: '18px',
    height: '50px',
  },
  SSOButton: {
    marginTop: '20px',
    width: '100%',
    borderColor: colors.OKTA_BLUE,
    color: colors.OKTA_BLUE,
    fontSize: '18px',
    height: '50px',
    borderWidth: 2,
    textTransform: 'none',
  },
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    padding: '15px',
    marginTop: '15px',
    maxWidth: '350px',
    minWidth: hostIsBoardwalk() ? '275px' : '300px',
  },
};

const StyledInput = styled(Input)`
  margin-top: 0.5rem;
  font-size: 16px;
  font-family: 'Circular';
`;

let Login = connect(
  (store) => ({
    showLoginForm: store.authentication.showLoginForm,
    loginErrorCode: store.authentication.loginErrorCode,
    loginErrorData: store.authentication.loginErrorData,
    showLoginDialog: store.authentication.showLoginDialog,
    isAuthenticating: store.authentication.showLoginForm,
    loginMessage: store.userTypes.loginMessage,
    verbiages: store.userTypes.verbiages,
    loginAuth: store.userTypes.loginAuth,
    resendConfirmationURL: store.userTypes.resendConfirmationURL,
    passwordResetURL: store.userTypes.passwordResetURL,
    landlordId: store.userTypes.landlordId,
    email: store.userTypes.email,
    createdSuccess: store.userTypes.createdSuccess,
    landlordSSOEnabled: store.userTypes.landlordSSOEnabled,
    uuid: store.userTypes.uuid,
    propertyTypes: store.userTypes.propertyTypes,
    userType: store.userTypes.userType,
    ssoProvidersLandlord: store.userTypes.ssoProvidersLandlord,
    ssoProvidersAgent: store.userTypes.ssoProvidersAgent,
  }),
  {
    showLoginError,
    toggleAuthenticationDialog,
    updateLanguage,
    setUserAsLead,
    setUserAsLandlord,
    setUserAsMaintenance,
    setLandlordLogo,
    logUserIn,
    showFailureFromUrlQuery,
    getCompanyPreferences,
    getPortfolios,
  }
)(
  class Login extends Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        username: '',
        password: '',
        mobileNumber: '',
        verificationCode: '',
        verificationMethod: 'mobile',
        isButtonEnabled: true,
        isAuthenticating: false,
        editingMobileNumber: false,
        loginHelpOpen: false,
        mobileNumberInputErrors: {
          required: null,
          validPhone: null,
        },
      };
    }

    componentDidMount() {
      if (this.props.location.query && this.props.location.query.error) {
        this.props.showFailureFromUrlQuery(this.props.location.query.error);
      }
    }

    handleInputChange = (event) => {
      this.setState({ [event.target.name]: event.target.value.trim() });
    };

    handleMobileNumberChange = (value) => {
      this.setState({ mobileNumber: value });
    };

    handleVerifyNumber = () => {
      const invalidPhoneVerbiage = getTranslatedString('validationErrors.invalidPhone');
      const requiredErrorVerbiage = getTranslatedString('required');
      const parseResult = parsePhoneNumberFromString(this.state.mobileNumber);
      if (this.state.mobileNumber === '') {
        this.setState((prevState) => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: requiredErrorVerbiage,
              validPhone: prevState.mobileNumberInputErrors.validPhone,
            },
          };
        });
      } else if (parseResult && parseResult.isValid()) {
        this.setState((prevState) => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: null,
              validPhone: null,
            },
          };
        });
        this.login();
      } else {
        this.setState((prevState) => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: prevState.mobileNumberInputErrors.required,
              validPhone: invalidPhoneVerbiage,
            },
          };
        });
      }
    };

    handleLoginHelpOpenClose = (openClose) => {
      this.setState({
        loginHelpOpen: openClose,
      });
    };

    getTranslatedLoginMessage = () => {
      const { propertyTypes, verbiages, loginMessage } = this.props;
      const isCommercial = propertyTypes === 'commercial';

      const residentLoginFromVerbiage =
        verbiages && verbiages['residentLogin'] && verbiages['residentLogin'][getCurrentLocale()];
      const landlordLoginFromVerbiage =
        verbiages && verbiages['landlordLogin'] && verbiages['landlordLogin'][getCurrentLocale()];

      if (loginMessage === 'residentLoginPortal' && (isCommercial || hostIsConcert())) {
        return getTranslatedString('tenantLoginPortal');
      } else if (loginMessage === 'residentLoginPortal' && residentLoginFromVerbiage) {
        return residentLoginFromVerbiage;
      } else if (loginMessage === 'landlordLoginPortal' && landlordLoginFromVerbiage) {
        return landlordLoginFromVerbiage;
      }

      return getTranslatedString(loginMessage);
    };

    login = () => {
      this.setState({ isAuthenticating: true });

      if (this.state.username === '' || this.state.password === '') {
        this.setState({ isAuthenticating: false });
        this.props.showLoginError('blankEmailPasswordError');
        return;
      }

      this.setState({ isButtonEnabled: false });

      const auth = Auth;
      Auth.emailSignIn({
        username: this.state.username,
        password: this.state.password,
        landlord_id: this.props.landlordId,
        mobile_number: this.state.mobileNumber.replace(/[()\\s-]+/gi, ''),
        verification_code: this.state.verificationCode,
        verification_method: this.state.verificationMethod,
        language_code: getCurrentLocale(),
        config: this.props.loginAuth,
      })
        .done((response) => {
          auth.configDfd = null;
          if (!this.props.showLoginDialog) {
            this.props.showLoginError(null);
          }
          if (
            response.data.id !== undefined &&
            this.props.loginAuth !== 'landlord' &&
            this.props.loginAuth !== 'maintenance'
          ) {
            this.props.setUserAsLead(response.data);
            if (!this.props.showLoginDialog) {
              this.props.router.replace('/dashboard' + browserHistory.getCurrentLocation().search);
            } else {
              this.props.toggleAuthenticationDialog(false);
              this.props.logUserIn();
            }
          } else if (
            response.data.id !== undefined &&
            this.props.loginAuth === 'landlord' &&
            this.props.loginAuth !== 'maintenance'
          ) {
            this.props.setUserAsLandlord(response.data);
            if (!this.props.showLoginDialog) {
              this.props.router.replace(
                dashboardForAgent(response.data.permission) +
                  browserHistory.getCurrentLocation().search
              );
            } else {
              this.props.toggleAuthenticationDialog(false);
              // eslint-disable-next-line
              localStorage.setItem('currentConfigName', '"landlord"');
              this.props.logUserIn();
            }
            if (browserHistory.getCurrentLocation().pathname.startsWith('/companies')) {
              this.props.getCompanyPreferences();
              this.props.getPortfolios();
            }
          } else if (
            response.data.id !== undefined &&
            this.props.loginAuth !== 'landlord' &&
            this.props.loginAuth === 'maintenance'
          ) {
            this.props.setUserAsMaintenance(response.data);
            this.props.router.replace(
              '/maintenance/dashboard' + browserHistory.getCurrentLocation().search
            );
          }
          this.handleSuccessfulLogin(response);
        })
        .catch((error) => {
          auth.configDfd = null;

          const errorStatus = error.data.error;

          if (errorStatus === 'invalid_credentials') {
            this.props.showLoginError('invalidLoginCredentials');
          } else if (errorStatus === 'blocked_access_from_ip') {
            this.props.showLoginError('blockedAccessFromIp');
          } else if (errorStatus === 'account_locked') {
            // Account locked
            this.props.showLoginError('accountLocked', {
              email: this.state.username,
            });
          } else if (errorStatus === 'unconfirmed') {
            // Uncomfirmed
            this.props.showLoginError('unconfirmedTemp');
            // temporarily showing a different error
            // once we fix email sending, change it back to 'unconfirmed'
            // and remove 'unconfirmedTemp' from global.locale.json
            // this.props.showLoginError('unconfirmed', { email: this.state.username });
          } else if (errorStatus === 'password_expired') {
            // Password expired
            this.props.showLoginError('passwordExpired', {
              email: this.state.email,
            });
          } else if (errorStatus === 'verify_mobile_number') {
            // Verify phone number
            this.setState({
              mobileNumber: error.data.mobile_number,
            });
            this.props.showLoginError('verifyMobileNumber', {
              email: this.state.email,
              mobileNumber: error.data.mobile_number,
            });
          } else if (errorStatus === 'verification_code') {
            // Verification token
            this.setState({
              verificationCode: '',
            });
            this.props.showLoginError('verificationCode', {
              email: this.state.email,
              mobileNumber: error.data.mobile_number,
            });
          } else {
            this.props.showLoginError('unknownError');
          }
          this.setState({ isButtonEnabled: true, isAuthenticating: false });
        });
    };

    handleSuccessfulLogin(response) {
      this.setState({ isAuthenticating: false });
      let language_code = 'en';
      if (response.data.language_code) {
        language_code = response.data.language_code;
      }
      this.props.updateLanguage(language_code);
      localStorage.setItem('locale', language_code);
      FullStory.identify(response.data.landlord_uuid + response.data.type + response.data.id);
      FullStory.setUserVars({
        email: response.data.email,
        displayName:
          response.data.landlord_name + '-' + response.data.type + '-' + response.data.first_name,
        landlord_id: response.data.landlord_id,
        landlord_name: response.data.landlord_name,
        user_type: response.data.type,
      });

      if (['production', 'dev', 'qa', 'staging', 'training'].includes(window.ENV)) {
        window.Rollbar.configure({
          payload: {
            person: {
              id: response.data.id, // required
              username: response.data.email,
              email: response.data.email,
            },
          },
        });
      }
    }

    editMobileNumber = () => {
      this.setState({
        editingMobileNumber: !this.state.editingMobileNumber,
      });
    };

    changeVerificationMethod = (method) => {
      this.setState(
        {
          verificationMethod: method,
        },
        () => {
          this.login();
        }
      );
    };

    resetVerificationCode = () => {
      this.setState({
        verificationCode: '',
      });
      this.login();
    };

    detectEnterKeyDown = (event) => {
      if (event.key === 'Enter') {
        this.login();
      }
    };

    render() {
      if (this.state.isAuthenticating) return this.renderLoading();
      if (!this.props.showLoginForm) return <span />;
      if (this.props.loginErrorCode === 'passwordExpired') return this.renderResetPassword();
      if (this.props.loginErrorCode === 'verifyMobileNumber')
        return this.renderValidateMobileNumber();
      if (this.props.loginErrorCode === 'verificationCode') return this.renderVerificationCode();
      if (this.props.loginErrorCode === 'alternative') return this.renderAlternative();
      return this.renderLogin();
    }

    renderLoading = () => {
      return (
        <section style={{ marginTop: '20px' }} role="main">
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div className="row" id={'loading-message'}>
                {this._renderTitle(this.getTranslatedLoginMessage())}
                <div
                  style={{
                    textAlign: 'center',
                    width: '60px',
                    margin: '30px auto 15px',
                  }}
                >
                  <BounceLoader color={AccentColor()} />
                </div>
                <h5 style={{ textAlign: 'center' }}>{getTranslatedString('login.loggingIn')}</h5>
              </div>
            </CardContent>
          </Card>
        </section>
      );
    };

    renderLogin = () => {
      const { isButtonEnabled } = this.state;

      let ssoProviders = [];
      if (this.props.landlordSSOEnabled === true && this.props.userType === 'agent') {
        ssoProviders = this.props.ssoProvidersLandlord || this.props.ssoProvidersAgent || [];
      }

      return (
        <section style={{ marginTop: '20px' }} role="main">
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div className="row" id={'main-login-message'}>
                {this._renderTitle(this.getTranslatedLoginMessage())}
                {this.props.loginErrorCode && (
                  <div
                    className="error-message"
                    id="error-message"
                    data-testid="login-error-message"
                  >
                    <WarningIcon />{' '}
                    {getTranslatedString(this.props.loginErrorCode, this.props.loginErrorData)}
                  </div>
                )}

                {this.props.createdSuccess && (
                  <div className="success-message" id={'success-message'}>
                    <CheckIcon />
                    {getTranslatedString('login.signupSuccess')}
                  </div>
                )}
              </div>
              {this.props.landlordSSOEnabled === true &&
                this.props.userType === 'agent' &&
                ssoProviders.map((ssoProvider) => {
                  return (
                    <SSOLoginButton
                      loginMessage={this.props.loginMessage}
                      SSOLoginUrl={`${constants.BASE_API_URL}/v1/saml/sso?landlord_id=${
                        this.props.uuid
                      }&provider=${ssoProvider}&lang=${getCurrentLocale()}`}
                      isButtonEnabled={isButtonEnabled}
                      ssoProvider={ssoProvider}
                    />
                  );
                })}
              {this.props.landlordSSOEnabled === true && this.props.userType === 'agent' && (
                <div className="row" style={{ textAlign: 'center' }}>
                  <h5 aria-level="1" style={{ padding: '10px 0' }}>
                    {getTranslatedString('landlordPortal.login.or')}
                  </h5>
                </div>
              )}
              <div className="row" style={{ textAlign: 'left' }}>
                <StyledInput
                  data-testid="login-email-input"
                  aria-label={getTranslatedString('email')}
                  name="username"
                  type="text"
                  placeholder={getTranslatedString('email')}
                  onChange={this.handleInputChange}
                  value={this.state.username}
                  onKeyDown={this.detectEnterKeyDown}
                />
                <StyledInput
                  data-testid="login-password-input"
                  aria-label={getTranslatedString('password')}
                  name="password"
                  type="password"
                  placeholder={getTranslatedString('password')}
                  onChange={this.handleInputChange}
                  value={this.state.password}
                  onKeyDown={this.detectEnterKeyDown}
                />
              </div>
              <FlatButton
                name="submit"
                aria-label={getTranslatedString('login')}
                data-testid="login-button"
                label={getTranslatedString('login')}
                id={'login-button'}
                primary={true}
                onClick={this.login}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <div id="account-links-container">
                <p className="account-link">
                  <a href={`/${this.props.passwordResetURL}`}>
                    {getTranslatedString('forgotPassword')}
                  </a>
                </p>
                <p className="account-link">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.handleLoginHelpOpenClose(true)}
                    aria-label={getTranslatedString('help')}
                  >
                    {getTranslatedString('help')}
                  </button>
                </p>
                <LanguageOptionsCentered onLanguageChange={() => this.forceUpdate()} />
              </div>
            </CardContent>
          </Card>
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="login"
            loginMessage={this.props.loginMessage}
            passwordResetURL={this.props.passwordResetURL}
            verbiages={this.props.verbiages}
          />
        </section>
      );
    };

    _renderTitle = (title) => {
      if (this.props.showLoginDialog) return;

      return (
        <h3 aria-level="1" style={{ padding: '0 0 10px' }}>
          {title}
        </h3>
      );
    };

    renderValidateMobileNumber = () => {
      const { isButtonEnabled } = this.state;
      const { loginErrorData } = this.props;
      return (
        <div style={{ marginTop: '20px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div className="row">
                <h3 style={{ padding: '0 0 10px' }}>{this.getTranslatedLoginMessage()}</h3>
                <p>
                  {getTranslatedString('login.verifyMobileNumber')}
                  <strong>{formatPhone(loginErrorData.mobileNumber)}</strong>
                </p>
              </div>

              {this._renderNotEditingMobileNumber()}
              {this._renderEditMobileNumber()}
              {this.state.mobileNumberInputErrors.required && (
                <FormHelperText
                  style={{
                    color: colors.RED,
                    position: 'relative',
                    left: '10px',
                    top: '5px',
                  }}
                >
                  {this.state.mobileNumberInputErrors.required}
                </FormHelperText>
              )}
              {this.state.mobileNumberInputErrors.validPhone && (
                <FormHelperText
                  style={{
                    color: colors.RED,
                    position: 'relative',
                    left: '10px',
                    top: '5px',
                  }}
                >
                  {this.state.mobileNumberInputErrors.validPhone}
                </FormHelperText>
              )}
              <FlatButton
                name="submit"
                label={getTranslatedString('login.verifyMobileNumberLabel')}
                primary={true}
                onClick={this.handleVerifyNumber}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <div id="account-links-container">
                <p className="account-link">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.handleLoginHelpOpenClose(true)}
                    aria-label={getTranslatedString('help')}
                  >
                    {getTranslatedString('help')}
                  </button>
                </p>
                <div style={{ marginTop: '10px' }}>
                  <LanguageOptionsCentered />
                </div>
              </div>
            </CardContent>
          </Card>
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="validateMobileNumber"
            loginMessage={this.props.loginMessage}
            verbiages={this.props.verbiages}
          />
        </div>
      );
    };

    _renderNotEditingMobileNumber = () => {
      if (this.state.editingMobileNumber) return;

      return (
        <div className="row">
          <p className="account-link">
            <button
              type="button"
              className="link-button"
              onClick={this.editMobileNumber}
              aria-label={getTranslatedString('login.editMobileNumber')}
            >
              {getTranslatedString('login.editMobileNumber')}
            </button>
          </p>
        </div>
      );
    };

    _renderEditMobileNumber = () => {
      if (!this.state.editingMobileNumber) return;

      return (
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2">
            <ReactPhoneInput
              name="mobileNumber"
              value={this.state.mobileNumber}
              onChange={this.handleMobileNumberChange}
            />
          </div>
        </div>
      );
    };

    renderVerificationCode = () => {
      const { isButtonEnabled, verificationMethod } = this.state;
      const { loginErrorData } = this.props;

      const mobileNumberInState = this.state.mobileNumber;
      let lastFourDigitsMobile = loginErrorData.mobileNumber;
      if (mobileNumberInState && mobileNumberInState.length === 10) {
        lastFourDigitsMobile = lastFourDigitsMobile.substring(6, 10);
      }

      return (
        <div style={{ marginTop: '20px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div className="row">
                <h3 style={{ padding: '0 0 10px' }}>{this.getTranslatedLoginMessage()}</h3>
                <p>
                  {getTranslatedString('login.sentVerificationCode')}{' '}
                  {verificationMethod === 'mobile'
                    ? `${getTranslatedString('login.lastFourMobileNumber')} ${lastFourDigitsMobile}`
                    : getTranslatedString('login.yourEmail')}
                </p>
              </div>
              <div className="row">
                <div className="col-sm-8 col-sm-offset-2">
                  <StyledInput
                    name="verificationCode"
                    type="text"
                    placeholder={getTranslatedString('verificationCode')}
                    onChange={this.handleInputChange}
                    value={this.state.verificationCode}
                    onKeyDown={this.detectEnterKeyDown}
                  />
                </div>
              </div>
              <FlatButton
                name="submit"
                label={getTranslatedString('login')}
                primary={true}
                onClick={this.login}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <div style={{ marginTop: '10px' }}>
                <p className="account-link">
                  {getTranslatedString('login.didntReceiveCode')}{' '}
                  <button
                    type="button"
                    className="link-button"
                    onClick={this.resetVerificationCode}
                    aria-label={getTranslatedString('login.tryAgain')}
                  >
                    {getTranslatedString('login.tryAgain')}
                  </button>
                </p>
                <p className="account-link">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.props.showLoginError('alternative')}
                    aria-label={getTranslatedString('login.tryAnotherWay')}
                  >
                    {getTranslatedString('login.tryAnotherWay')}
                  </button>
                </p>
                <p className="account-link">
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.handleLoginHelpOpenClose(true)}
                    aria-label={getTranslatedString('help')}
                  >
                    {getTranslatedString('help')}
                  </button>
                </p>
                <div style={{ marginTop: '10px' }}>
                  <LanguageOptionsCentered />
                </div>
              </div>
            </CardContent>
          </Card>
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="verificationCode"
            loginMessage={this.props.loginMessage}
            verbiages={this.props.verbiages}
          />
        </div>
      );
    };

    renderAlternative = () => {
      const { isButtonEnabled } = this.state;
      return (
        <div style={{ marginTop: '20px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div className="row">
                <h3 style={{ padding: '0 0 10px' }}>{this.getTranslatedLoginMessage()}</h3>
                <p>{getTranslatedString('login.havingTrouble')}</p>
              </div>
              <FlatButton
                name="submit"
                label="Send code via SMS"
                primary={true}
                onClick={() => this.changeVerificationMethod('mobile')}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <FlatButton
                name="submit"
                label="Send via Email"
                primary={true}
                onClick={() => this.changeVerificationMethod('email')}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
              <FlatButton
                name="help"
                label="Help"
                primary={true}
                onClick={() => this.handleLoginHelpOpenClose(true)}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                disabled={!isButtonEnabled}
                labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
                style={style.button}
              />
            </CardContent>
          </Card>
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="alternative"
            loginMessage={this.props.loginMessage}
            verbiages={this.props.verbiages}
          />
        </div>
      );
    };

    renderResetPassword = () => {
      return (
        <div style={{ marginTop: '20px' }}>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div>
                <h3 style={{ padding: '0 0 10px' }}>
                  {getTranslatedString(this.props.loginMessage)}
                </h3>
                {this.props.loginErrorCode && (
                  <div className="error-message" id="error-message">
                    <WarningIcon />{' '}
                    {getTranslatedString(this.props.loginErrorCode, this.props.loginErrorData)}
                  </div>
                )}
              </div>
              <FlatButton
                name="submit"
                label={getTranslatedString('resetPassword')}
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
                onClick={() => browserHistory.push(`/${this.props.passwordResetURL}`)}
              />
              <p className="account-link">
                <button
                  type="button"
                  className="link-button"
                  onClick={() => this.handleLoginHelpOpenClose(true)}
                  aria-label={getTranslatedString('help')}
                >
                  {getTranslatedString('help')}
                </button>
              </p>
              <div style={{ marginTop: '10px' }}>
                <LanguageOptionsCentered />
              </div>
            </CardContent>
          </Card>
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage="passwordExpired"
            loginMessage={this.props.loginMessage}
            verbiages={this.props.verbiages}
          />
        </div>
      );
    };
  }
);

const SSOLoginButton = ({ SSOLoginUrl, isButtonEnabled, ssoProvider }) => {
  return (
    <Button
      name="sign_in_with_sso"
      primary={true}
      onClick={() => (window.location = SSOLoginUrl)}
      disabled={!isButtonEnabled}
      labelStyle={{ fontSize: '18px' }}
      style={style.SSOButton}
      variant="outlined"
    >
      <SSOIcon provider={ssoProvider} /> {getTranslatedString(`signInWith${titleize(ssoProvider)}`)}
    </Button>
  );
};

const SSOIcon = ({ provider }) => {
  if (provider === 'azure') {
    return (
      <img
        alt="microsoft sso login button"
        style={{ width: '35px', paddingRight: '5px' }}
        src={msIcon}
      />
    );
  }
  if (provider === 'okta') {
    return (
      <img
        alt="okta sso login button"
        style={{ width: '28px', paddingRight: '7px' }}
        src={oktaIcon}
      />
    );
  }

  return null;
};

export default withRouter(localize()(Login));
